import _slicedToArray from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { jsx } from 'react/jsx-runtime';
import { createContext, useMemo, useContext } from 'react';
import { useUpdater } from '../../../hooks/use-updater.js';
var initialState = {
  loading: true,
  data: {}
};
var WarzoneLeaderboardContext = createContext(initialState);
var WarzoneLeaderboardProvider = function WarzoneLeaderboardProvider(_ref) {
  var initialData = _ref.data,
    updateFunc = _ref.updateFunc,
    updateInterval = _ref.updateInterval,
    children = _ref.children;
  var _useUpdater = useUpdater(initialData, updateFunc, updateInterval),
    _useUpdater2 = _slicedToArray(_useUpdater, 3),
    data = _useUpdater2[0],
    loading = _useUpdater2[2].loading;
  var value = useMemo(function () {
    return {
      data: data,
      loading: loading
    };
  }, [data, loading]);
  return /* @__PURE__ */jsx(WarzoneLeaderboardContext.Provider, {
    value: value,
    children: children
  });
};
var useWarzoneLeaderboard = function useWarzoneLeaderboard() {
  return useContext(WarzoneLeaderboardContext);
};
var useWarzoneLeaderboardForFaction = function useWarzoneLeaderboardForFaction(factionId) {
  var _useWarzoneLeaderboar = useWarzoneLeaderboard(),
    loading = _useWarzoneLeaderboar.loading,
    data = _useWarzoneLeaderboar.data;
  var leaderboard = useMemo(function () {
    if (loading) {
      return {};
    }
    return data[factionId] || {};
  }, [data, factionId, loading]);
  return {
    leaderboard: leaderboard,
    loading: loading
  };
};
var useGlobalWarzoneLeaderboard = function useGlobalWarzoneLeaderboard() {
  return useWarzoneLeaderboardForFaction(0);
};
var useWarzoneLeaderboardStats = function useWarzoneLeaderboardStats(factionId, group) {
  var _useWarzoneLeaderboar2 = useWarzoneLeaderboardForFaction(factionId),
    loading = _useWarzoneLeaderboar2.loading,
    leaderboard = _useWarzoneLeaderboar2.leaderboard;
  var _useMemo = useMemo(function () {
      var _a, _b;
      if (loading) {
        return {
          kills: [],
          victoryPoints: []
        };
      }
      return {
        kills: (_a = leaderboard["kills".concat(group)]) != null ? _a : [],
        victoryPoints: (_b = leaderboard["points".concat(group)]) != null ? _b : []
      };
    }, [leaderboard, group, loading]),
    kills = _useMemo.kills,
    victoryPoints = _useMemo.victoryPoints;
  return {
    kills: kills,
    victoryPoints: victoryPoints,
    loading: loading
  };
};
var useGlobalWarzoneLeaderboardStats = function useGlobalWarzoneLeaderboardStats(group) {
  return useWarzoneLeaderboardStats(0, group);
};
export { WarzoneLeaderboardProvider, useGlobalWarzoneLeaderboard, useGlobalWarzoneLeaderboardStats, useWarzoneLeaderboard, useWarzoneLeaderboardForFaction, useWarzoneLeaderboardStats };